<script>
export default {
  props: ["value"],
  data: function () {
    let prePromotionalRate = 9999999;
    let currency = "MXN";

    if (Array.isArray(this.value) && this.value.length === 2) {
      [prePromotionalRate, currency] = this.value;
    }
    const number = Math.round(prePromotionalRate);

    return {
      number,
      currency,
    };
  },
};
</script>

<template>
  ${{ number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") }} {{ currency }}
</template>
